import React from "react";

const MembershipActionCard = (props) => {
    const {levelData, title, description, price, expiration, cta, setSelectedMembership, intent, setIntent, setCartTotal, setActiveScreen, order} = props;

    return (
        <div className="action-card invert" style={{'order': order}}>
            <div className="action-card__meta">
                <h3 className="action-card__title">{title}</h3>
                <p className="action-card__description">{description}</p>
                <button
                    className="button"
                    onClick={() => {
                        setIntent(intent);
                        setSelectedMembership(levelData);
                        setCartTotal(intent == 'MembershipUpgrade' ? levelData.offerings[0].priceLists[0].prices[0].discountedPrice : levelData.offerings[0].priceLists[0].prices[0].price);
                        setActiveScreen('selection');
                        window.scrollTo(0, 200);
                    }}
                >
                    {cta}
                </button>
            </div>
            <div className="action-card__highlight">
                <h2 className="action-card__price">${price}</h2>
                <p className="action-card__expiration">{(intent.search(/upgrade/i) == -1 && intent.search(/RenewalUpgrade/i) == -1) ? 'New expiration date' : 'Expires on'}<br/><b>{expiration}</b></p>
            </div>
        </div>
    );

}

export default MembershipActionCard;